<!-- for Browse by Port -->
<div class="card h-auto" *ngIf="browseType=='port'">
  <div *ngIf="!showQualityCard" class="card-header stripe d-flex p-2"
  [ngStyle]="{'background-color':productInfo.headerColor}">
    <!-- <div class="small strong ml-1">{{productInfo.shortDescription}}</div> -->
    <div class="small bold ml-auto pe-auto mr-2" (mousedown)="viewQuality()"><u>{{
        'home.productHeader.ViewQuality' | cxTranslate }}</u> </div>
  </div>
  <div *ngIf="showQualityCard" class="card-header stripe bg-dark quality-card-strip d-flex pt-1 pb-1 pl-2 pr-2">
  </div>
  <div *ngIf="!showQualityCard" class="card-body">
    <div class="card-title mb-4">
      <span class="line-clamp h5 strong overflow-hidden">{{productInfo.name}}</span>
      <div class="text-secondary line-clamp-single mt-1 h5">
        {{port.name}}
      </div>
    </div>
    <div class="d-flex justify-content-between min-h-4 text-secondary">
      <div class="width-70 small">
        <div>{{ 'home.productHeader.Vessel' | cxTranslate }}</div>
        <div class=""><span
            class="strong line-clamp-single line-clamp-single-vessel" title="{{productInfo.vesselName | uppercase}}">{{productInfo.vesselName|uppercase}}</span></div>
      </div>
      <div class="width-30 small">
        <div>{{ 'home.productHeader.Voyage' | cxTranslate }}</div>
        <div class="strong">{{productInfo.voyageId}}</div>
      </div>
    </div>
    <hr class="line-horizontal">
    <div class="d-flex justify-content-between mb-2">
      <div class="width-48">
        <div class="small text-secondary mb-1">{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}</div>
        <div>
          <!-- <span class=" currency-icon position-absolute ml-2 mt-2" >{{productInfo.price!=undefined?productInfo.price.currencyIso:''}}&nbsp;</span> -->
          <span class="fs-10 currency-icon position-absolute">{{'home.productHeader.rmb' | cxTranslate}}&nbsp;</span>
          <input [(ngModel)]="productPrice"  class="input-field space bold p-3 border bg-white" appTwoDigitDecimaNumber (keypress)="checkPriceValidation($event)" onkeypress="return event.charCode != 45">
          <div class="wrapper mobicon">
            <div class="icon ">
              <div class="tooltip text-white">
                <div class="tooltip-value">{{ 'home.productHeader.tooltipValue' | cxTranslate }}</div>
              </div>
              <span data-toggle="tooltip" data-placement="right" class="badge bg-light badge-pill ques-mark">?</span>
            </div>
          </div>
        </div>
        <div class="text-secondary fs-10 text-right">{{ 'home.productHeader.incOfTaxes' | cxTranslate }}</div>
      </div>
      <div class="width-48">
        <div class="small text-secondary mb-1">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}</div>
        <div >
          <!-- <select *ngIf="!showquantity" [(ngModel)]="quantitySelected" class="round-radius text-black input-field border pl-2 bold bg-white">
            <option value="{{p}}" *ngFor="let p of quantityRangeArrya">{{p}}</option>
          </select> -->
          <input numeric allowPositiveAndNegativeNumbers  type="text" [maxlength]="maxLen"  [(ngModel)]="quantitySelected"  class="input-field space bold p-3 border bg-white"  required >
         
        </div>
          <div>
            <!-- <select *ngIf="showquantity" [(ngModel)]="actualQuantitySelected" class="round-radius text-black input-field border pl-2 bold bg-white">
            <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
          </select> -->
          <input *ngIf="showquantity" numeric allowPositiveAndNegativeNumbers type="text" [maxlength]="maxLen"  [(ngModel)]="actualQuantitySelected"  class="input-field space bold p-3 border bg-white"  required >

        </div>
        <p *ngIf="qtyEmptyErr" class="text-danger my-1 md-semibold-font fs-10">{{ 'home.productHeader.qtyRequiredCheck' | cxTranslate }}</p>
        <p *ngIf="qtyValidErr" class="text-danger my-1 err-font ">{{ 'home.productHeader.qtyValidCheck' | cxTranslate }}{{this.productInfo.minimumQty+'-'+this.productInfo.maximumQty}}</p><!--<p *ngIf="qtyValidErr" class="text-danger my-1 err-font ">{{ rangeValidationErrMsg | cxTranslate}}</p>-->

      </div>
    </div>
    <button [disabled]="isPlaceBidDisabled" class="btn btn-primary w-100" (mousedown)="openModal(content,productInfo)">{{
      'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
  </div>
  <div *ngIf="showQualityCard && qualityChunked " style="
  border-radius: 0px 0px 10px 10px;height:212px;margin-top: -13px;" class="card-body view-quality-card-body bg-dark">
    <!-- dynamic quality list -->
    <div class="text-white small text-center" *ngIf="productInfo.noQualityDetails"> {{ 'home.productHeader.notAvailable' | cxTranslate }}</div>
    <div *ngFor="let i of qualityChunked,let j=index">
      <div class="quality-part1" *ngIf="j==selectedPart" id="viewquality{{j}}">
        <ul class="quality-list">
          <li class="text-white" type="none" *ngFor="let m of i">
            <div
              *ngIf="(m.key !== 'sizelowest') && (m.key !== 'sizemax') && (m.key !== 'qualityId') "
              class="d-flex justify-content-between">
              <span class="small strong">{{m.key}} </span>
              <span class="small text-white">{{m.value}}%</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="text-center mt-n4">
      <span class="p-1" *ngFor="let c of qualityChunked,let k=index" id="toggleBtn{{k}}"><i
          class="far fa-window-minimize text-secondary pe-auto" (click)="toggleQualityPart(k)"
          [class.active-class]="k==selectedPart"></i>
      </span>
    </div> -->
    <button class="btn close-quality-view bg-secondary text-white fw-14 border-0 btn-block"
      (mousedown)="showQualityCard = !showQualityCard">{{
      'home.productHeader.Close' | cxTranslate }}</button>
  </div>
  <div class="card-next-line position-absolute d-none top-0 left-0 w-100 h-100"></div>
</div>
<!-- for Browse by Product -->
<div class="card h-auto" *ngIf="browseType=='productType'">
  <div *ngIf="!showQualityCard" class="card-header stripe d-flex p-2"
  [ngStyle]="{'background-color':productInfo.headerColor}">
    <!-- <div class="small strong ml-1">{{productInfo.shortDescription}}</div> -->
    <div class="small bold ml-auto pe-auto mr-2" (click)="viewQuality()"><u>{{
        'home.productHeader.ViewQuality' | cxTranslate }}</u> </div>
  </div>
  <div *ngIf="!showQualityCard" class="card-body">
    <div class="card-title mb-4">
      <span class="line-clamp h5 strong overflow-hidden">{{productInfo.name}}</span>
      <div class="text-secondary line-clamp-single mt-1 h5">
        {{productInfo.ports.length !==0?productInfo.ports[0].name?productInfo.ports[0].name:'':''}}
      </div>
    </div>
    <div class="d-flex justify-content-between min-h-4 text-secondary">
      <div class="width-70 small">
        <div>{{ 'home.productHeader.Vessel' | cxTranslate }}</div>
        <div class="vessel-text-div"><span
            class="line-clamp-single strong line-clamp-single-vessel" title="{{productInfo.vesselName | uppercase}}">{{productInfo.vesselName|uppercase}}</span></div>
      </div>
      <div class="width-30 small">
        <div>{{ 'home.productHeader.Voyage' | cxTranslate }}</div>
        <div class="strong vessel-text-div">{{productInfo.voyageId}}</div>
      </div>
    </div>
    <hr class="line-horizontal">
    <div class="d-flex justify-content-between mb-2">
      <div class="width-48 small">
        <div class="small text-secondary mb-1">{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}</div>
        <div>
          <!-- <span class=" currency-icon position-absolute ml-2 mt-2" >{{productInfo.price!=undefined?productInfo.price.currencyIso:''}}&nbsp;</span> -->
          <span class=" currency-icon position-absolute">{{'home.productHeader.rmb' | cxTranslate}}&nbsp;</span>
          <input [(ngModel)]="productPrice" class="input-field space bold p-3 border bg-white" appTwoDigitDecimaNumber (keypress)="checkPriceValidation($event)" onkeypress="return event.charCode != 45">
          <div class="wrapper mobicon">
            <div class="icon ok">
              <div class="tooltip text-white">
                <div class="tooltip-value"> {{ 'home.productHeader.tooltipValue' | cxTranslate }}</div>
              </div>
              <span data-toggle="tooltip" data-placement="right" class="badge bg-light badge-pill ques-mark">?</span>
            </div>
          </div>
        </div>
        <div class="text-secondary fs-10 text-right">{{ 'home.productHeader.incOfTaxes' | cxTranslate }}</div>
      </div>
      <div class="width-48 cols small">
        <div class="small text-secondary mb-1">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}</div>
        <div>
          <!-- <select *ngIf="!showquantity" name="" id="" [(ngModel)]="quantitySelected"
            class="round-radius text-black  input-field border pl-2 small strong bg-white">
            <option value="{{p}}" *ngFor="let p of quantityRangeArrya">{{p}}</option>
          </select> -->
          <input allowPositiveAndNegativeNumbers numeric type="text" maxlength="maxLen" min="minQty" max="maxQty" [(ngModel)]="quantitySelected" class="input-field space bold p-3 border bg-white"  required >
          

        </div>
          <div>
            <!-- <select *ngIf="showquantity" [(ngModel)]="actualQuantitySelected" class="round-radius text-black input-field border pl-2 bold bg-white">
            <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
          </select> -->
          <input *ngIf="showquantity" numeric allowPositiveAndNegativeNumbers type="text" maxlength="maxLen" min="minQty" max="maxQty" [(ngModel)]="actualQuantitySelected"  class="input-field space bold p-3 border bg-white"  required >

        </div>
        <p *ngIf="qtyEmptyErr" class="text-danger my-1 md-semibold-font fs-10">{{ 'home.productHeader.qtyRequiredCheck' | cxTranslate }}</p>
        <p *ngIf="qtyValidErr" class="text-danger my-1  err-font">{{ 'home.productHeader.qtyValidCheck'| cxTranslate }} {{this.productInfo.minimumQty+'-'+this.productInfo.maximumQty}}</p><!--<span
        class="text-danger my-1 err-font" title="{{rangeValidationErrMsg | cxTranslate}}">{{rangeValidationErrMsg | cxTranslate}}</span> -->
      </div>
    </div>
    <button [disabled]="isPlaceBidDisabled" class="btn btn-primary w-100" (mousedown)="openModal(content,productInfo)">{{
      'home.productHeader.SendBidtoQuote' |
      cxTranslate }}</button>
  </div>
  <div *ngIf="showQualityCard" class="card-header stripe bg-dark quality-card-strip">
  </div>
  <div *ngIf="showQualityCard" style="
  border-radius: 0px 0px 10px 10px;height:212px;margin-top: -13px;" class="card-body view-quality-card-body bg-dark">
    <!-- dynamic quality list -->
    <div class="text-white small text-center" *ngIf="productInfo.noQualityDetails">{{ 'home.productHeader.notAvailable' | cxTranslate }}</div>
    <div *ngFor="let i of qualityChunked,let j=index">
      <div class="quality-part1" *ngIf="j==selectedPart" id="viewquality{{j}}">
        <ul class="quality-list">
          <li class="text-white" type="none" *ngFor="let m of i">
            <div
              *ngIf="(m.key !== 'sizelowest') && (m.key !== 'sizemax') && (m.key !== 'qualityId') "
              class="d-flex justify-content-between">
              <span class="small strong">{{m.key}} </span>
              <span class="small text-white">{{m.value}}%</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="text-center mt-n4">
      <span *ngFor="let c of qualityChunked,let k=index" id="toggleBtn{{k}}" class="p-1"><i
          class="far fa-window-minimize text-secondary pe-auto" (click)="toggleQualityPart(k)"
          [class.active-class]="k==selectedPart"></i>
      </span>
    </div> -->
    <button class="btn close-quality-view bg-secondary text-white fw-14 border-0 btn-block"
      (click)="showQualityCard = !showQualityCard">{{
      'home.productHeader.Close' | cxTranslate }}</button>
  </div>
  <div class="new-page position-absolute d-none top-0 left-0 w-100 h-100"></div>
</div>

<!-- for Browse by All -->
<div  class="d-flex justify-content-center">
  <div class="card browse-all-card m-browse-all-Card" *ngIf="browseType=='browseAll' || browseType=='quotesDetails'">
    <div *ngIf="!showQualityCard" class="card-header stripe d-flex p-2"
    [ngStyle]="{'background-color':productInfo.headerColor}">
      <!-- <div class="small ml-1">{{productInfo.shortDescription}}</div> -->
      <div class="small bold ml-auto pe-auto mr-2" (click)="viewQuality()"><u>{{
          'home.productHeader.ViewQuality' | cxTranslate }}</u> </div>
    </div>
    <div *ngIf="!showQualityCard" class="card-body">
      <div class="card-title mb-4">
        <span class="line-clamp h5 strong overflow-hidden">{{productInfo.name}}</span>
        <div class="text-secondary line-clamp-single mt-1 h5">
          {{productInfo.ports.length !==0?productInfo.ports[0].name?productInfo.ports[0].name:'':''}}
        </div>
      </div>
      <div class="d-flex justify-content-between min-h-4 text-secondary">
        <div class="width-70 small">
          <div>{{ 'home.productHeader.Vessel' | cxTranslate }}</div>
          <div class=""><span
              class="strong line-clamp-single strong line-clamp-single-vessel" title="{{productInfo.vesselName | uppercase}}">{{productInfo.vesselName|uppercase}}</span></div>
        </div>
        <div class="width-30 small">
          <div>{{ 'home.productHeader.Voyage' | cxTranslate }}</div>
          <div class="strong">{{productInfo.voyageId}}</div>
        </div>
      </div>
      <hr class="line-horizontal">
      <div class="d-flex justify-content-between mb-2">
        <div class="width-48 small">
          <div class="small text-secondary mb-1">{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}</div>
          <div>
            <!-- <span class=" currency-icon position-absolute ml-2 mt-2" >{{productInfo.price!=undefined?productInfo.price.currencyIso:''}}&nbsp;</span> -->
            <span class=" currency-icon position-absolute">{{'home.productHeader.rmb' | cxTranslate}}&nbsp;</span>
            <input [(ngModel)]="productPrice"  class="input-field space bold p-3 border bg-white" (keypress)="checkPriceValidation($event);validateDecimalPointPrice($event)" appTwoDigitDecimaNumber onkeypress="return event.charCode != 45">
            <div class="wrapper mobicon">
              <div class="icon ok">
                <div class="tooltip text-white">
                  <div class="tooltip-value">{{ 'home.productHeader.tooltipValue' | cxTranslate }}</div>
                </div>
                <span data-toggle="tooltip" data-placement="right" class="badge bg-light badge-pill ques-mark">?</span>
              </div>
            </div>
          </div>
          <div class="text-secondary fs-10 text-right">{{ 'home.productHeader.incOfTaxes' | cxTranslate }}</div>
        </div>
        <div class="width-48 small">
          <div class="small text-secondary mb-1">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}</div>
          <div >
            <!-- <select *ngIf="!showquantity" name="" id="" [(ngModel)]="quantitySelected"
              class="round-radius text-black  input-field border pl-2 small strong bg-white">
              <option value="{{p}}" *ngFor="let p of quantityRangeArrya">{{p}}</option>
            </select> -->
            <input  allowPositiveAndNegativeNumbers numeric type="text" maxlength="maxLen" min="minQty" max="maxQty" [(ngModel)]="quantitySelected"  class="input-field space bold p-3 border bg-white"  required >
          
          </div>
            <div>
              <!-- <select *ngIf="showquantity" [(ngModel)]="actualQuantitySelected" class="round-radius text-black input-field border pl-2 bold bg-white">
              <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
            </select> -->
            <input *ngIf="showquantity" numeric allowPositiveAndNegativeNumbers type="text" maxlength="maxLen" min="minQty" max="maxQty" [(ngModel)]="actualQuantitySelected"  class="input-field space bold p-3 border bg-white"  required >

          </div>
          <p *ngIf="qtyEmptyErr" class="text-danger my-1 md-semibold-font fs-10">{{ 'home.productHeader.qtyRequiredCheck' | cxTranslate }}</p>
           <p *ngIf="qtyValidErr" class="text-danger my-1  err-font">{{  'home.productHeader.qtyValidCheck' | cxTranslate }} {{this.productInfo.minimumQty+'-'+this.productInfo.maximumQty}}</p><!--<span
          class="text-danger my-1 err-font" title="{{rangeValidationErrMsg | cxTranslate}}">{{rangeValidationErrMsg | cxTranslate}}</span> -->

        </div>
      </div>
      <button [disabled]="isPlaceBidDisabled" *ngIf="browseType!=='quotesDetails'" class="btn btn-primary w-100"
        (mousedown)="openModal(content,productInfo)">{{
        'home.productHeader.SendBidtoQuote' |
        cxTranslate }}</button>
    </div>
    <div *ngIf="showQualityCard" class="card-body view-quality-browse-all view-quality-card-body bg-dark">
      <!-- dynamic quality list -->
      <div class="text-white small text-center" *ngIf="productInfo.noQualityDetails">{{ 'home.productHeader.notAvailable' | cxTranslate }}</div>
      <div *ngFor="let i of qualityChunked,let j=index">
        <div class="quality-part1" *ngIf="j==selectedPart" id="viewquality{{j}}">
          <ul class="quality-list">
            <li class="text-white" type="none" *ngFor="let m of i">
              <div
                *ngIf="(m.key !== 'sizelowest') && (m.key !== 'sizemax') && (m.key !== 'qualityId') "
                class="d-flex justify-content-between">
                <span class="small strong">{{m.key}} </span>
                <span class="small text-white">{{m.value}}%</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="text-center mt-n4">
        <span *ngFor="let c of qualityChunked,let k=index" id="toggleBtn{{k}}" class="p-1"><i
            class="far fa-window-minimize text-secondary pe-auto" (click)="toggleQualityPart(k)"
            [class.active-class]="k==selectedPart"></i>
        </span>
      </div> -->
      <button class="btn close-quality-view bg-secondary text-white fw-14 border-0 btn-block"
        (click)="showQualityCard = !showQualityCard">{{
        'home.productHeader.Close' | cxTranslate }}</button>
    </div>
    <div class="new-page position-absolute d-none top-0 left-0 w-100 h-100"></div>
  </div>
</div>

<!-- counter offer resusable modal component -->
<app-confirm-bid-modal #modal [modalConfig]="modalConfig">
  <!--  body of the modal  -->
</app-confirm-bid-modal>
